import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Page, PageMetadata, PaginationFilter } from '@tran-monorepo/interfaces';
import { Application, ApplicationStatusEnum, CreateApplication, Kpi } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApplicationsService {
    private readonly http = inject(HttpClient);

    private readonly apiUrl = `${environment.apiUrl}/v1/applications`;

    public getUserApplications(
        paginationFilter: PaginationFilter,
        statuses?: ApplicationStatusEnum[]
    ): Observable<Page<Application, PageMetadata>> {
        let params = new HttpParams();

        for (const [key, value] of Object.entries(paginationFilter)) {
            if (value !== null && value !== undefined) {
                params = params.set(key, String(value));
            }
        }

        if (statuses && statuses.length > 0) {
            params = params.set('statuses', statuses.join(','));
        }

        return this.http.get<Page<Application, PageMetadata>>(`${environment.apiUrl}/v1/me/applications`, {
            params
        });
    }

    public getApplication(id: string): Observable<Application> {
        return this.http.get<Application>(`${this.apiUrl}/${id}`);
    }

    public getApplicationKpis(id: string): Observable<Kpi[]> {
        return this.http.get<Kpi[]>(`${this.apiUrl}/${id}/kpis`);
    }

    public createApplication(application: CreateApplication): Observable<Application> {
        return this.http.post<Application>(this.apiUrl, application);
    }

    public updateApplication(applicationId: string, application: CreateApplication): Observable<Application> {
        return this.http.patch<Application>(`${this.apiUrl}/${applicationId}`, application);
    }

    public submitApplication(applicationId: string): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${applicationId}/submit`, {});
    }

    public deleteApplication(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
